import '@fortawesome/fontawesome-free/css/all.css'

import Vue from 'vue'

import App from './App'

import './config/bootstrap-vue'
import './config/axios'
import './config/msgs'
import './config/money'

import store from './config/store'
import router from './config/router'
import Vuelidate from './config/vuelidate'


Vue.config.productionTip = false

new Vue({
  store,
  router,
  Vuelidate,
  render: h => h(App)
}).$mount('#app')


// Azul: #313177
// Amarelo: #f7b930